/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Button, Row, Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';
import { setCurrencyFormat } from '../../../../utils/helpers';


const ViewMonthlySubOrderModel = ({
    isOpen,
    handleModal,
    data,
    tableHeaderData,
    fileName,
    title,
}) => {
    const excelData = data.map((item) => {
        const updated = { ...item };
        const { amount, orderCount, quantity } = updated
        updated.amount = setCurrencyFormat(Number(amount).toFixed(2), true);
        updated.orderCount = setCurrencyFormat(Number(orderCount).toFixed(0), false);
        updated.quantity = setCurrencyFormat(Number(quantity).toFixed(0), false);
        return updated

    })

    const handleDownload = () => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];

        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = excelData?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];

        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');

        // Write the file
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };


    return (
        <Modal
            isOpen={isOpen}
            toggle={() => handleModal(true)}
            style={{ maxWidth: '800px' }}
            className="modal-dialog ltr-support"
            centered
        >
            <div className="modal__header">
                <button
                    className="lnr lnr-cross modal__close-btn"
                    aria-label="modal__close-btn"
                    type="button"
                    onClick={() => handleModal(false)}
                />
                <h4 className="text-modal  modal__title">{title || 'Report'}</h4>
                <div className="ExcelTable">
                    <Button
                        disabled={!data.length}
                        className="download-monthly-sub-order-report btn-primary btn btn-sm"
                        onClick={handleDownload}
                    >
                        Download
                    </Button>
                </div>
            </div>
            <div className="modal__body">
                <Row style={{ position: 'relative' }}>
                    <ResizableDataTable customClass="pt-0" reactTableData={{ tableHeaderData }} data={excelData} />
                </Row>
            </div>
        </Modal>
    );
};

ViewMonthlySubOrderModel.propTypes = {
    handleModal: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
    fileName: PropTypes.string,
    title: PropTypes.string,
};

ViewMonthlySubOrderModel.defaultProps = {
    fileName: '',
    title: '',
};

export default ViewMonthlySubOrderModel;
